function formatDurationToMS(duration: number) {
  const seconds = Math.floor(duration % 60);
  const minutes = Math.floor(duration / 60);

  return `${minutes}m ${seconds}s`;
}

export const DateTimeUtils = {
  formatDurationToMS,
};
